<template>
  <button
    v-if="
      this.getProfile &&
        this.getProfile.isAdmin &&
        this.tournament &&
        this.tournament.reward &&
        this.tournament.currentRound > this.tournament.totalRounds
    "
    class="button is-success is-small"
    @click="rewardPlayers"
  >
    Reward Players
  </button>
</template>

<script>
import { firestore } from "@/services/firebase";
import { mapGetters } from "vuex";

export default {
  name: "AdminReward",
  props: ["rankedPlayers", "tournament", "reward"],

  computed: {
    ...mapGetters(["getProfile"]),
  },

  methods: {
    async rewardPlayers() {
      console.log("rewardPlayers", this.tournament.name);
      for (const player of this.rankedPlayers) {
        const tournamentId = this.tournament.tournamentId || this.tournament.id;
        console.log("reward", tournamentId, player.username, player.reward);
        if (player.reward) {
          await firestore
            .collection("metadata")
            .doc(player.username)
            .collection("rewards")
            .doc("tournament_" + tournamentId)
            .set({
              type: "tournament",
              tournament: {
                ...this.tournament,
                id: tournamentId,
                players: null,
                rounds: null,
                games: null,
              },
              player: player,
              reward: player.reward,
            });
        } else {
          await firestore
            .collection("metadata")
            .doc(player.username)
            .collection("rewards")
            .doc("tournament_" + tournamentId)
            .delete();
        }
      }
    },
  },
};
</script>

<style></style>
